import { CSSProperties, ReactElement } from "react";
import { isAzureMode } from "./system/security";
import { isKioskMode } from "./configuration/configuration";
import LeftPanel from "./components/leftPanel";
import RightPanel from "./components/rightPanel";
import Header from "./components/header";
import ContentArea from "./components/ContentArea";
import BottomPanel from "./components/bottomPanel";
import { Alert, Snackbar } from "@mui/material";
import { delAlert } from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "./types";
import { setDimension } from "./system/resolutionController";
import useDimensions from "./system/useDimensions";

const HideIn3Sec = 3000;

setDimension();

const MainContainer = (): ReactElement => {
  const dispatch = useDispatch<any>();
  const bottom = useSelector((state: IState) => state.panels.bottom);
  const alerts = useSelector((state: IState) => state.alerts);
  const [ref, dimensions] = useDimensions<HTMLDivElement>();

  const contentStyle: CSSProperties = {
    position: "relative",
    display: "grid",
    width: "100%",
    height: "100dvh",
    minHeight: "100dvh",
    maxHeight: "100dvh",
    gridTemplateColumns: "1fr",
    gridTemplateRows: isAzureMode() && !isKioskMode() ? "65px 1fr auto" : "0px 1fr auto"
  };

  const content: CSSProperties = {
    position: "relative",
    overflow: "auto",
    gridColumn: "1 / 1",
    gridRow: "2 / span 1",
    alignSelf: "stretch",
    justifySelf: "stretch"
  };

  const menu = {
    gridColumn: "1 / 1",
    gridRow: "3 / span 1",
    alignSelf: "stretch",
    overflow: "auto",
    width: "100%",
    height: bottom ? 65 : 0
  };


  return (
    // <div style={parentStyle} >
    <div style={contentStyle} className="unselectable">
      {isAzureMode() && !isKioskMode() &&
        <>
          <LeftPanel/>
          <RightPanel/>
          <Header/>
        </>
      }
      <div style={content} id={"ContentAreaID"} ref={ref}>
        <ContentArea parentSize={{ width: dimensions.width - 2, height: dimensions.height - 2 }}/>
      </div>
      { !isKioskMode() &&
        <div style={menu}>
          <BottomPanel/>
        </div>
      }

      {alerts.length > 0 &&
        <Snackbar open={true} onClose={() => dispatch(delAlert(alerts[0].hash as string))}
          autoHideDuration={HideIn3Sec} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert onClose={() => dispatch(delAlert(alerts[0].hash as string))} severity={alerts[0].severity} variant="filled">
            {alerts[0].message}
          </Alert>
        </Snackbar>
      }
    </div>
    // </div>
  );
};

export default MainContainer;